import * as React from 'react';
import { useOptionLayout } from './useOptionLayout';
import { usePreviousValue } from 'owa-react-hooks/lib/usePreviousValue';

export const enum FlyoutLevel {
    Closed = 0,
    Subcategories = 1 << 0,
    Categories = 1 << 1,
    SubcategoriesAndCategories = FlyoutLevel.Subcategories | FlyoutLevel.Categories,
}

/**
 * Function to get value and setter for a FlyoutLevel state value,
 * and reset the value to Closed if the option layout changes
 */
export function useFlyoutLevelState(): [
    FlyoutLevel,
    React.Dispatch<React.SetStateAction<FlyoutLevel>>
] {
    const layout = useOptionLayout();
    const previousLayout = usePreviousValue(layout);
    const [flyoutLevel, setFlyoutLevel] = React.useState<FlyoutLevel>(FlyoutLevel.Closed);

    if (layout !== previousLayout) {
        setFlyoutLevel(FlyoutLevel.Closed);
        return [FlyoutLevel.Closed, setFlyoutLevel];
    }

    return [flyoutLevel, setFlyoutLevel];
}
